<div class="layers-editor">
  <div class="mainMenu">
    <div class="groups">
      @for (group of membersMenu$ | async; track group) {
        <div class="group">
          {{ group.label }}
          @if (group.canAdd) {
            <lib-button
              (click)="addMembersGroup.emit(group)"
              icon-only
              >
              <mat-icon>add</mat-icon>
            </lib-button>
          }
        </div>
      }

      <div class="group">
        Uczeń wiodący
        @if ((leadingChild$ | async)?.canAdd) {
          <lib-button
            (click)="addLeadingChild.emit({})"
            icon-only
            >
            <mat-icon>add</mat-icon>
          </lib-button>
        }
      </div>

      <div class="group">
        Uczeń wiodący - zdjęcie
        @if ((leadingChildPhotoOnly$ | async)?.canAdd) {
          <lib-button
            (click)="addLeadingChild.emit({ isPhotoOnly: true })"
            icon-only
            >
            <mat-icon>add</mat-icon>
          </lib-button>
        }
      </div>

      <div class="group">
        Uczeń wiodący - podpis
        @if ((leadingChildNameOnly$ | async)?.canAdd) {
          <lib-button
            (click)="addLeadingChild.emit({ isNameOnly: true })"
            icon-only
            >
            <mat-icon>add</mat-icon>
          </lib-button>
        }
      </div>

      <div class="group">
        Zdjęcie placówki
        <lib-button (click)="addSchoolPhoto.emit()" icon-only>
          <mat-icon>add</mat-icon>
        </lib-button>
      </div>

      <div class="group">
        Zdjęcie z sesji
        <lib-button (click)="addChildStaticPhoto.emit()" icon-only>
          <mat-icon>add</mat-icon>
        </lib-button>
      </div>
    </div>

    <div class="names">
      @for (name of namesMenu$ | async; track trackTextName($index, name)) {
        <div
          class="name"
          >
          {{ name.name }}
          @if (name.canAdd) {
            <lib-button (click)="addText.emit(name)" icon-only>
              <mat-icon>add</mat-icon>
            </lib-button>
          }
        </div>
      }

      @if ((organizationLogo$ | async)?.canAdd) {
        <div class="name">
          Logo placówki
          <lib-button (click)="addLogo.emit()" icon-only>
            <mat-icon>add</mat-icon>
          </lib-button>
        </div>
      }

      @if ((photographerLogo$ | async)?.canAdd) {
        <div class="name">
          Moje logo
          <lib-button (click)="addPhotographerLogo.emit()" icon-only>
            <mat-icon>add</mat-icon>
          </lib-button>
        </div>
      }

      <div class="name">
        Własny tekst
        <lib-button (click)="addStaticText.emit()" icon-only>
          <mat-icon>add</mat-icon>
        </lib-button>
      </div>

      <div class="name">
        Grafika
        <lib-button icon-only class="addGraphic">
          <mat-icon>add</mat-icon>
          <input type="file" (change)="addGraphic.emit($event)" />
        </lib-button>
      </div>

      @if (!isSinglePageTablo) {
        <div class="name">
          KOD QR
          <lib-button (click)="addQr.emit()" icon-only>
            <mat-icon>add</mat-icon>
          </lib-button>
        </div>
      }
    </div>
  </div>
</div>
